import { useTranslation } from 'react-i18next';

import { useHistory } from '@treams/treams-routes';

import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import useAuthenticatedUser from 'packages/kakapo-ui-application/hooks/useAuthenticatedUser';
import { useMixpanel } from 'packages/kakapo-ui-application/hooks/useMixpanel';

import InboxTaskItem from '../components/InboxTaskItem';

export default function InboxEvaluationOpenTask({
	task,
	onAction,
	refresh,
}: {
	task: graphql.InboxTask;
	onAction: () => void;
	refresh: () => void;
}) {
	const mixpanel = useMixpanel();
	const history = useHistory();
	const { t } = useTranslation();
	const authenticatedUser = useAuthenticatedUser();
	const { localize } = useLocalize();
	const [archive] = graphql.useArchiveInboxTaskMutation();

	const evaluation = task.evaluationSubmission!;

	const isEmployee = evaluation.employee.user.id === authenticatedUser.id;

	const { employee, manager } = evaluation;

	const status = isEmployee ? employee.status : manager.status;

	const requiresInput = isEmployee ? employee.requiresInput : manager.requiresInput;

	const canSign = isEmployee ? employee.viewerCanSign : manager.viewerCanSign;

	const momentName = localize(
		evaluation.moment?.momentTemplate.title ?? evaluation.evaluationForm.title,
	).text;

	const onClick = () => {
		mixpanel?.track('inbox.tasks.evaluationOpen.view');
		onAction();
		history.push(`/user/${employee.user.id}/evaluations-v2/${evaluation.id}`);

		if (!requiresInput && !canSign) {
			archive({ variables: { input: { id: task.id } } });
		}
	};

	return (
		<InboxTaskItem
			task={task}
			onClick={onClick}
			title={t(
				`inbox.tasks.${
					requiresInput
						? status === graphql.EvaluationSubmissionStatus.Draft
							? 'evaluationFillInAndShare'
							: 'evaluationToSign'
						: 'evaluationNoInput'
				}${isEmployee ? 'Self' : ''}.title`,
				{
					momentName,
					targetEmployeeFullName: `${employee.user.firstName} ${employee.user.lastName}`,
				},
			)}
			date={task.createdAt}
			buttonTitle={t('inbox.tasks.button.view')}
			refresh={refresh}
		/>
	);
}
